import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

/* Footer - custom React component ...................................................................................... [START] */
const Footer = () => {

  /* JSX code "return ( ..."................................................................................... [START] */
  return (
    /* footer - Bootstrap component ................................................................. [START] */
    <footer className='site-footer'>
      {/* container ....................................................................... [START] */}
      <Container>
        {/* row ................................................................. [START] */}
        <Row>
          {/* col #1 .................................................. [START] */}
          <Col xs={{ size: 4, offset: 1 }} sm='2'>
            <h5>Links</h5>
            <ul className='list-unstyled'>
              <li>
                <Link to='/'>Home</Link>
              </li>
              <li>
                <Link to='/directory'>Directory</Link>
              </li>
              <li>
                <Link to='/about'>About</Link>
              </li>
              <li>
                <Link to='/contact'>Contact</Link>
              </li>
            </ul>
          </Col>
          {/* col #1 .................................................... [END] */}
          {/* col #2 .................................................. [START] */}
          <Col xs='6' sm='3' className='text-center'>
            <h5>Social</h5>
            <a
              className='btn btn-social-icon btn-instagram'
              href='http://instagram.com/'
            >
              <i className='fa fa-instagram' />
            </a>{' '}
            <a
              className='btn btn-social-icon btn-facebook'
              href='http://www.facebook.com/'
            >
              <i className='fa fa-facebook' />
            </a>{' '}
            <a
              className='btn btn-social-icon btn-twitter'
              href='http://twitter.com/'
            >
              <i className='fa fa-twitter' />
            </a>{' '}
            <a
              className='btn btn-social-icon btn-google'
              href='http://youtube.com/'
            >
              <i className='fa fa-youtube' />
            </a>
          </Col>
          {/* col #2 .................................................... [END] */}
          {/* col #3 .................................................. [START] */}
          <Col sm='4' className='text-center'>
            <a
              role='button'
              className='btn btn-link'
              href='tel:+12065551234'
            >
              <i className='fa fa-phone' /> 1-206-555-1234
            </a>
            <br />
            <a
              role='button'
              className='btn btn-link'
              href='mailto:notreal@notreal.co'
            >
              <i className='fa fa-envelope-o' /> campsites@nucamp.co
            </a>
          </Col>
         {/* col #3 ..................................................... [END] */}
        </Row>
        {/* row ................................................................... [END] */}
      </Container>
      {/* container ......................................................................... [END] */}
    </footer>
    /* footer - Bootstrap component ................................................................. [START] */
  )
  /* JSX code "...)"............................................................................................. [END] */
  
};

export default Footer;
/* Footer - custom React component ........................................................................................ [END] */
